<template>
  <div class="home">
    <HeaderComponent screenName=""/>
    <!-- Business Banner -->
    <BannerComponent
      imageSrc="capabilities/health It services/healthcare-banner.jpg"
      :bannerHeadingColor="'#fff'"
      :isOverlay="true"
      heading="Health IT Services"
      subheading="Pioneering Innovation for a Brighter, Healthier Future"
    />

    <div class="modernization-description" data-aos="fade-up">
      <v-row>
        <v-col
          :xs="12"
        >
          <p> {{ appModernizationDesc }} </p>
        </v-col>
      </v-row>
    </div>
    <CardComponent 
      :subHeading="`BENEFITS`"
      :cardItems="benefitsItems"
    />
    <CardComponent 
      :subHeading="`CORE CAPABILITIES`"
      :cardItems="coreCapabilitiesItems"
    />
    <SectionComponent
      relatedTitle="RELATED CAPABILITIES"
      :paragraphContent="paragraphContent"
      :sections="sectionContents"
      :cards="cardData"
      :additional-content="additionalContent"
    />
    <FooterComponent />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, Ref } from 'vue';

// Components
import HeaderComponent from '@/components/HeaderComponent.vue';
import BannerComponent from '@/components/BannerComponent.vue';
import CardComponent from '@/components/CardComponent.vue';
import SectionComponent from '@/components/SectionComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default defineComponent({
  components: {
    HeaderComponent,
    BannerComponent,
    CardComponent,
    SectionComponent,
    FooterComponent
  },
  data() {
    return {
      appModernizationDesc: 'Healthcare transcends merely diagnosis and treatment; it is a well-balanced blend of individuals, processes, and leading-edge technology. This encompasses not just the physicians and their patients, but extends to administrators, intricate networks, and the ever-advancing information technology (IT) systems that underpin this complex environment. At G14C, we possess a deep understanding of the vital role Healthcare Organizations play in elevating the quality of care, reducing or altogether eliminating errors, and promoting value-based healthcare. We are committed to guiding your organization through a transformative journey that revolutionizes communications, operations, data defense, security, and analysis within the vast healthcare landscape. Together, our unwavering focus is paramount in delivering the highest standard of Healthcare IT Services for the Healthcare industry.',
      benefitsItems: [
        {
          id: 0,
          subFolder:'capabilities', 
          folder:'health It services',
          imageUrl: 'cloud-security.jpg',
          text: 'Cloud Security',
          hoverIcon: 'vector.png',
          hoverText: 'Identifying and collecting data from various virtual machines, cloud storage, and software-as-a-service (SaaS) applications performing log analysis, file carving, data recovery, and metadata analysis, to identify events and  potential threats or malicious activity.'
        },{
          id: 1,
          subFolder:'capabilities', 
          folder:'health It services',
          imageUrl: 'Agility.jpg',
          text: 'Increase Agility',
          hoverIcon: 'chart.png',
          hoverText: 'Leveraging our Agile development approach and DevSecOps capabilities to continuously integrate and continuously deliver applications and services in the Cloud infrastructure.'
        },{
          id: 2,
          subFolder:'capabilities', 
          folder:'health It services',
          imageUrl: 'innovation.jpg',
          text: 'Innovation',
          hoverIcon: 'trend-down.png',
          hoverText: 'Fosters innovation by enabling the development of new technologies, services, and business models to drive economic growth, cost effectiveness while improving quality.'
        },{
          id: 3,
          subFolder:'capabilities', 
          folder:'health It services',
          imageUrl: 'Application.jpg',
          text: 'Optimize the Application Footprint',
          hoverIcon: 'lock.png',
          hoverText: 'Balancing the portfolio of applications based on business value, technical fit, and costs ensuring the application and system footprint is optimized.'
        }
      ],
      coreCapabilitiesItems: [
        {
          id: 4,
          subFolder:'capabilities', 
          folder:'health It services',
          imageUrl: 'Application Modernization.jpg',
          text: 'Application Modernization',
          hoverIcon: 'analysis.png',
          hoverText: 'Accelerates the modernization of legacy applications, software and platforms. Provides analysis and engineering capabilities for converting, rewriting, and migrating outdated applications utilizing modern computer programming languages, architectures, software libraries, and protocols.'
        },{
          id: 5,
          subFolder:'capabilities', 
          folder:'health It services',
          imageUrl: 'Business Intelligence.jpg',
          text: 'Business Intelligence',
          hoverIcon: 'inventory.png',
          hoverText: 'Improves Healthcare Organizations with Business Intelligence capabilities so leadership can make accurate decisions based on actionable information. Our services provide military leadership with the information they need to improve processes, reporting capabilities, and situational awareness.'
        },{
          id: 6,
          subFolder:'capabilities', 
          folder:'health It services',
          imageUrl: 'cloud.jpeg',
          text: 'Cloud',
          hoverIcon: 'ai-brain.png',
          hoverText: 'Streamlines the process and approach for building, deploying, and managing applications, services, and infrastructure in the Cloud. We utilize and administer Cloud platforms, such as Amazon Web Services (AWS), Microsoft Azure, and Google Cloud Platform (GCP), to rapidly and continuously develop and deploy applications and services.'
        },{
          id: 7,
          subFolder:'capabilities', 
          folder:'health It services',
          imageUrl: 'cybersecurity.jpg',
          text: 'Cybersecurity',
          hoverIcon: 'cloud-done.png',
          hoverText: 'Strengthens capabilities for Information System Security Officer as a Service (ISSOaaS) for designing and developing cybersecurity solutions, and processes to protect Healthcare infrastructure, networks, systems, applications, and data. Our cyber experts develop and implement cyber solutions that identify, minimize, isolate and mitigate cyber threats.'
        },{
          id: 8,
          subFolder:'capabilities', 
          folder:'health It services',
          imageUrl: 'devsecops.jpg',
          text: 'DevSecOps',
          hoverIcon: 'software-license.png',
          hoverText: 'Optimizes the approach for rapidly building, deploying, and managing applications, services, and infrastructure for modernizing systems and applications. Utilizes best practices and principles to integrate security into the development and operations process to rapidly and continuously develop and deploy applications and services.'
        },{
          id: 9,
          subFolder:'capabilities', 
          folder:'health It services',
          imageUrl: 'digital-health.jpg',
          text: 'Digital Health Services',
          hoverIcon: 'microservices.png',
          hoverText: 'Provides the Healthcare Industry with a broad range of capabilities and solutions delivered electronically utilizing digital technology including Software as a Service (SaaS), Platform as a Service (PaaS), Infrastructure as a Service (IaaS), Cloud Computing, Cloud Storage and Data Services, and Digital Health Services.'
        }
      ],
      paragraphContent: `G14C remains at the forefront of the industry, renowned for our exceptional expertise in a diverse range of transformative services and capabilities, including application modernization, business intelligence, cloud computing, cybersecurity, artificial intelligence (AI), DevSecOps, and digital services. Our unwavering commitment to innovation and adaptability ensures that we meet the unique demands of both federal and commercial enterprises. What sets us apart is our technology-agnostic philosophy, allowing us to create and implement tailor-made solutions perfectly attuned to your specific Health IT requirements. When you embark on a partnership with G14C, you gain unparalleled access to our elite team of Health IT professionals, experts with extensive experience, from diverse backgrounds, including former healthcare practitioners, veterans, and knowledgeable professionals with detailed experience in federal and commercial healthcare environments.`,
      sectionContents: [
        '“The Centers for Medicare and Medicaid Services (CMS), Information, Security and Privacy Group (ISPG), Division of Implementation and Reporting (DIR) recognizes and extends our appreciation for the exceptional support on the OA Program Status Dashboard task using Security Data Lake (SDL) sourced data to show value from the SDL efforts. The value that you are bringing through the work you do creates the foundation for collaboration across teams and functions within ISPG. This was the first realized concept and linchpin in contextualizing the capabilities of the SDL and a job well done!”',
        '“The delivery team recommended that ESG’s account onboarding process would benefit from the ability to provide a modern FDA account generation solution. With this functionality our users have an easier time onboarding which has resulted in less help desk inquiries. The ESG staff find this functionality helpful as it reduces confusion and time spent on account creation. Using this solution greatly reduces the time to receive an ESG account because this solution automates several processes. The solution was rapidly designed, developed, and deployed and many of our customers find the solution very helpful.”',
      ],
      additionalContent: [
        'CMS, Director, Division of Implementation and Reporting (DIR)', 
        'FDA, Program Manager', 
      ],
      cardData: [
        {
          className: 'cloud',
          color: '#7594FE',
          heading: 'Cloud',         
          link: 'cloud'
        },
        {
          className: 'devsecops',
          color: '#50E1FE',
          heading: 'Application Modernization	',         
          link: 'application-modernization'
        },
        {
          className: 'security',
          color: '#E2BF66',
          heading: 'Cyber Security',         
          link: 'cyber-security'
        },
      ]
    };
  },
  setup() {
    return {
    };
  },
});
</script>
<style scoped>
.modernization-description{
  padding: 32px;
  padding-left: 100px;
  padding-right: 100px;
}
.modernization-description div div p{
  font-size: 24px;
}
@media (max-width: 1000px) {
  .modernization-description{
    padding: 27px;
    padding-left: 80px;
    padding-right: 80px;
  }
  .modernization-description div div p{
    font-size: 24px;
  }
}
@media (max-width: 850px) {
  .modernization-description{
    padding: 22px;
    padding-left: 65px;
    padding-right: 65px;
  }
  .modernization-description div div p{
    font-size: 22px;
  }
}
@media (max-width: 750px) {
  .modernization-description{
    padding: 17px;
    padding-left: 50px;
    padding-right: 50px;
  }
  .modernization-description div div p{
    font-size: 20px;
  }
}
@media (max-width: 600px) {
  .modernization-description{
    padding: 12px;
    padding-left: 35px;
    padding-right: 35px;
  }
  .modernization-description div div p{
    font-size: 18px;
  }
}
</style>